import React from 'react'
import { Container } from './styles'

interface ModalListProceduresProps {
  title: string
  children: React.ReactNode
}

const ModalListProcedures = ({ title, children }: ModalListProceduresProps): JSX.Element => {
  return (
    <Container>
      <h3>{title}</h3>
      <hr data-testid="hr" />
      {children}
    </Container>
  )
}

export { ModalListProcedures }
